import { createContext } from "react";

//types
import { TableColumnsItem } from "../../../common/FiltersComponents/TableSettings/types";

interface IWebhooksReportContext {
  selectedWebhooks: TableColumnsItem[],
  setSelectedWebhooks: (data: any) => void;
  addSelectedWebhooks: (data: any) => void;
  showBulkLimitAlert: () => void;
}

export const WebhooksReportContext = createContext<IWebhooksReportContext>({
  selectedWebhooks: [],
  setSelectedWebhooks: () => {},
  addSelectedWebhooks: () => {},
  showBulkLimitAlert: () => {},
});
